/*
 * Vencord, a modification for Discord's desktop app
 * Copyright (c) 2022 Vendicated and contributors
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
*/

(window.VencordStyles ??= new Map()).set("src/plugins/messageLogger/deleteStyleText.css", {
    name: "src/plugins/messageLogger/deleteStyleText.css",
    source: ".messagelogger-deleted {\n    --text-default: var(--status-danger, #f04747);\n    --interactive-icon-default: var(--status-danger, #f04747);\n    --text-muted: var(--status-danger, #f04747);\n    --embed-title: var(--red-460, #be3535);\n    --text-link: var(--red-460, #be3535);\n    --text-strong: var(--red-460, #be3535);\n}",
    classNames: {},
    dom: null,
});

export default "src/plugins/messageLogger/deleteStyleText.css";
